import React, { FunctionComponent } from 'react';
import {
  II18n,
  I18nService,
  BrassTextField,
  BrassTextFieldProps,
} from '../../../../';

const translations: II18n = {
  es: {
    nameLabel: 'Nome',
  },
  enUS: {
    nameLabel: 'Name',
  },
  ptBR: {
    nameLabel: 'Nome',
  },
};

const translate = (key: string, args?: string[]): string =>
  new I18nService(translations).translate(key, args);

const NameField: FunctionComponent<BrassTextFieldProps> = (
  props: BrassTextFieldProps,
) => (
  <BrassTextField
    {...props}
    required={false}
    name='name'
    label={translate('nameLabel')}
    style={{ width: 600 }}
  />
);

export { NameField };
